import React, { useEffect, useState } from 'react';
import Hero from '../Hero';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import Cta from '../Cta';
import MovingText from '../MovingText';
import VideoModal from '../VideoModal';
import TimelineSlider from '../Slider/TimelineSlider';
import { pageTitle } from '../../helper';
import WhoWeAre from '../WhoWeAre';
import ProductSlider from '../Slider/ProductSlider';
import InsightSlider from '../Slider/InsightSlider';
import VerticalScrollServices from '../ServiceSlide/VerticalScrollServices';
import ProjectSlider from '../Slider/ProjectSlider';
import axios from 'axios';
import BASE_URL from '../../utils/api';

const heroSocialLinks = [
  {
    name: 'FaceBook',
    links: 'https://www.facebook.com/share/16DuTzTF6H/',
  },
  {
    name: 'Linkedin',
    links: 'https://www.linkedin.com/company/lixrinnovation/',
  },
];

const educationData = [
  {
    title: 'Bachelor In Web Technology',
    subTitle: 'University Of Florida | 2008-20012',
  },
  {
    title: 'Masters In Graphic Design',
    subTitle: 'University Of Coventry | 2013-2015',
  },
  {
    title: 'Diploma In Motion Graphic',
    subTitle: 'University Of Florida | 2018-20020',
  },
];

const experienceData = [
  {
    title: 'Senior Graphic Designer',
    subTitle: 'Web Tech | 2022-2024',
  },
  {
    title: 'Project Manager',
    subTitle: 'Awesome Themez | 2020-2022',
  },
  {
    title: 'Word Press Developer',
    subTitle: 'Mount Soft IT | 2018-2020',
  },
];

export default function Home() {
  pageTitle('Home');
  const [projectSliderData, setProjectSliderData] = useState([]);
  const [achievements, setAchievements] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchSliderProjects = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/projects/`);
        const formatted = response.data.map(project => ({
          title: project.projectName,
          subtitle: 'See Details',
          href: `/project`,
          src: project.projectImages?.[0] || '/images/default.jpg'
        }));
        setProjectSliderData(formatted);
      } catch (err) {
        console.error('Failed to fetch slider projects', err);
      }
    };

    fetchSliderProjects();
  }, []);

  useEffect(() => {
  const fetchAchievements = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/achievements`);
      const formatted = res.data
        .slice(0, 4)
        .map(item => ({
          title: item.title,
          description: item.description,
          year: item.year,
        }));
      setAchievements(formatted);
    } catch (error) {
      console.error('Failed to fetch achievements:', error);
    }
  };

  fetchAchievements();
}, []);

  return (
    <>
      {/* Start Hero Section */}
      <Hero
        title="Move Fast. <br/>Break Stuff & Iterate"
        subtitle="We provide advanced engineering 
          solutions through specialized design, 
          simulation, and manufacturing services, 
          serving a broad spectrum of industries."
        btnText="Get a Quote"
        btnLink="/contact"
        scrollDownId="#service"
        socialLinksHeading="Follow Us"
        heroSocialLinks={heroSocialLinks}
        bgImageUrl="/images/bg01.png"
      />
      {/* End Hero Section */}

      {/* Start FunFact Section */}
      <div className="container">
        <WhoWeAre
        variant="cs-type1"
        title="Who we are"
        subtitle1="LIXR Innovations is a cutting-edge engineering company that offers a wide range of services such as design, 
        simulation, rendering, and advanced engineering solutions."
        subtitle2 ="Our team is comprised of highly experienced mechanical, manufacturing, mechatronics, and electrical engineers 
        who can offer complete and innovative solutions for different industries."
        />
      </div>
      {/* End FunFact Section */}

      {/* Start Service Section */}
      <Div className="" id="service">
        <Spacing lg="150" md="80" />
        <VerticalScrollServices />
      </Div>     

      {/* Start project Section */}
      <Spacing lg="150" md="50" />
      <Div data-aos="fade-up" data-aos-duration="2000">
        <Div className="container" data-aos="fade-up" data-aos-duration="2000">
          <SectionHeading
            title="Excellence in Execution"
            subtitle="Recent Projects"
            variant="cs-style1 text-center"
          />
          <Spacing lg="90" md="45" />
        </Div>
        <ProjectSlider data={projectSliderData} />
      </Div>
      {/* End Portfolio Section */}

      
      <Spacing lg="150" md="80" />
      <section
        className="cs-fixed_bg"
        style={{ backgroundImage: `url(images/resume_bg.jpeg)` }}
        data-aos="fade-up" data-aos-duration="2000"
      >
        <div className="cs-height_145 cs-height_lg_75" />
        <div className="container">
          <SectionHeading
            title="Awards & Achievements"
            subtitle=""
            variant="cs-style1 text-center"
            data-aos="fade-up" data-aos-duration="2000"
          />
          <Spacing lg="90" md="45" />
          <div className="cs-list_2_group">
            <ul className="cs-list cs-style_2 cs-mp0" data-aos="fade-up" data-aos-duration="2000">
              {achievements.slice(0, Math.ceil(achievements.length / 2)).map((item, index) => (
                <li key={index}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="cs-accent_color"
                    viewBox="0 0 24 24"
                  >
                    <path d="M21 3h-4V2a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1v2a5.006 5.006 0 0 0 4 4.9V11a6.994 6.994 0 0 0 5 6.708V20H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-2.292A6.994 6.994 0 0 0 18 11v-.1a5.006 5.006 0 0 0 4-4.9V4a1 1 0 0 0-1-1ZM4 6V5h3v3.874A3.005 3.005 0 0 1 4 6Zm16 0a3.005 3.005 0 0 1-3 2.874V5h3Z" />
                  </svg>
                  <h3>{item.title}</h3>
                  <p className="mb-1"><strong>{item.year}</strong></p>
                  <p className="mb-0">
                    {item.description.length > 100 ? `${item.description.slice(0, 100)}...` : item.description}
                  </p>
                </li>
              ))}
            </ul>
            <ul className="cs-list cs-style_2 cs-mp0" data-aos="fade-up" data-aos-duration="2000">
              {achievements.slice(Math.ceil(achievements.length / 2)).map((item, index) => (
                <li key={index}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="cs-accent_color"
                    viewBox="0 0 24 24"
                  >
                    <path d="M21 3h-4V2a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1v2a5.006 5.006 0 0 0 4 4.9V11a6.994 6.994 0 0 0 5 6.708V20H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-2.292A6.994 6.994 0 0 0 18 11v-.1a5.006 5.006 0 0 0 4-4.9V4a1 1 0 0 0-1-1ZM4 6V5h3v3.874A3.005 3.005 0 0 1 4 6Zm16 0a3.005 3.005 0 0 1-3 2.874V5h3Z" />
                  </svg>
                  <h3>{item.title}</h3>
                  <p className="mb-1"><strong>{item.year}</strong></p>
                  <p className="mb-0">
                    {item.description.length > 100 ? `${item.description.slice(0, 100)}...` : item.description}
                  </p>
                </li>
              ))}
            </ul>
          </div>
          
        </div>
        <div className="cs-height_80 cs-height_lg_80" />
        <div className="text-center mt-4" data-aos="fade-up" data-aos-duration="2000">
          <a href="/all-achievements" className="cs-text_btn cs-type1">
            <span>See More Achievements</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
              style={{ marginLeft: '6px' }}
            >
              <path d="M1 8a.5.5 0 0 1 .5-.5h11.793L10.146 4.354a.5.5 0 1 1 .708-.708l4.0 4.0a.5.5 0 0 1 0 .708l-4.0 4.0a.5.5 0 1 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
            </svg>
          </a>
        </div>
        <div className="cs-height_80 cs-height_lg_80" />
        
      </section>

      {/* Start Video Block Section */}
      <Spacing lg="130" md="70" />
       <Div className="" data-aos="fade-up" data-aos-duration="2000">
        <h2 className="cs-font_50 cs-m0 text-center cs-line_height_4"> Bold in vision. Precise in execution. Dedicated to impact. 
        </h2>
        <Spacing lg="70" md="70" />
        <VideoModal
          videoSrc="https://www.youtube.com/watch?v=iAo-fWPTuBg"
          bgUrl="/images/video_bg.jpeg"
        />
      </Div>
      {/* End Video Block Section */}

      {/* Start product Section */}
      <Spacing lg="150" md="80" />
      <Div className="cs-shape_wrap_4" data-aos="fade-up" data-aos-duration="2000">
        <Div className="cs-shape_4"><img src="/images/circle_lixr.png" alt="Logo" /></Div>
        <Div className="cs-shape_4"><img src="/images/logo-lixr5.png" alt="Logo" /></Div>
        
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="Our Products Discover"
                subtitle="Our Products"
                btnText="What's New"
                btnLink="/all-products"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-7 offset-xl-1">
              <Div className="cs-half_of_full_width">
                <ProductSlider />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      {/* End Blog Section */}

      <Spacing lg="145" md="80" />

      {/* Start Testimonial Section */}
      <InsightSlider />
      {/* End Testimonial Section */}

      

      {/* Start MovingText Section */}
      <Spacing lg="125" md="70" />
      <MovingText text="Looking for an innovation? we are here to hold your back" />
      <Spacing lg="105" md="70" />
      {/* End MovingText Section */}

      {/* Start LogoList Section */}
      <Div className="container">
        {/* <LogoList /> */}
      </Div>
      <Spacing lg="150" md="80" />
      {/* End LogoList Section */}

      {/* Start CTA Section */}
      <Div className="container" data-aos="fade-up" data-aos-duration="2000">
        <Cta
          title="Interested in Innovating <br /><i>Together?</i>"
          btnText="Get in Touch"
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
      {/* End CTA Section */}
    </>
  );
}
